
import { defineComponent, PropType } from "vue"
import DashboardSidebar from "@/js/Pages/Dashboard/_Sidebar.vue"
import DashboardNavbar from "@/js/Pages/Dashboard/_Navbar.vue"
import { Service, Frame } from "@/js/types/service"
import Home from "@/js/Pages/Dashboard/_Home.vue"

export default defineComponent({
    name: "DashboardPage",
    components: { Home, DashboardSidebar, DashboardNavbar },
    props: {
        userServices: {
            type: Object as PropType<Service[]>,
            required: true,
        },
    },
    data: () => ({
        frames: [] as Frame[],
        openedTab: NaN,
    }),
    computed: {
        sortedFramesByDate(): Frame[] {
            /**
             * Это computed-свойство необходимо для рендеринга iframe всегда в одном и том же порядке
             * Так как при изменении порядка вкладок Navbar могут обновится iframe`ы
             */
            const frames = [...this.frames]
            return frames.sort(
                (a, b) => new Date(b.openedAt).getTime() - new Date(a.openedAt).getTime(),
            )
        },
        openedFrame(): Frame {
            return this.frames[this.openedTab]
        },
    },
    mounted() {
        window.addEventListener("message", (message: MessageEvent) => {
            console.log("Received message:", message)

            const frame = Array.from(
                (this.$refs.content as HTMLElement).querySelectorAll("iframe"),
            ).find((node: HTMLIFrameElement) => {
                const window = node.contentWindow || (node.contentDocument as any).defaultView

                return window === message.source
            })

            if (!frame) {
                console.info("unable to get sender frame")
                return
            }

            if (message.data === "login" || message.data === "restart") {
                if (message.data === "login") {
                    const confirmState = confirm("Выполнить вход через портал?")

                    if (!confirmState) return
                }

                const frameIndex = this.frames.findIndex((item) => item.id === frame.dataset.id)

                if (frameIndex === -1) {
                    console.info("unable to find frame by following id:", frame.dataset.id)
                    return
                }

                // @ts-ignore
                frame.src = this.frames[frameIndex].openUrl
            } else if (message.data?.command === "openService") {
                const service = this.userServices.find(
                    (service: Service) => service.name === message.data?.service,
                )

                if (service) {
                    this.openService(service, true, true, message.data?.params)
                }
            }
        })

        this.openAgentDashboard()
    },
    methods: {
        updateFramesOrder(frames: Frame[]) {
            const currentFrameId = this.frames[this.openedTab].id

            this.frames = frames

            const openedTab = this.frames.findIndex((frame) => frame.id === currentFrameId)

            if (openedTab !== -1) {
                this.openedTab = openedTab
            }
        },
        openFrame(frameIndex: number) {
            this.openedTab = frameIndex
        },
        openService(
            service: Service,
            forceInNewTab: boolean = false,
            closable: boolean = true,
            params?: any,
        ) {
            if (!forceInNewTab && this.openedTab) {
                const currentTab = this.frames[this.openedTab]

                // Проверяем относится ли текущая вкладка к открываемому сервису
                // Если да, то открываем сервис в новой вкладке
                // Если же нет, то ищем первую вкладку с этим сервисом и открываем её
                if (currentTab.service.id !== service.id) {
                    const tabIndex = this.frames.findIndex(
                        (frame) => frame.service.id === service.id,
                    )

                    if (tabIndex !== -1) {
                        this.openedTab = tabIndex
                        return
                    }
                }
            }

            let openUrl = service.url

            if (params) {
                openUrl += "?" + new URLSearchParams(params).toString()
            }

            const length = this.frames.push({
                id: Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
                service,
                title: service.title,
                openUrl: openUrl,
                openedAt: new Date(),
                closable: closable,
            })

            this.openedTab = length - 1
        },
        closeFrame(frameIndex: number) {
            this.frames = this.frames.filter((frame: Frame, index: number) => index !== frameIndex)

            if (this.frames.length > 0 && this.openedTab > 0) this.openedTab--
        },
        openAgentDashboard() {
            const agentDashboardService: Service = {
                id: 3,
                name: "agent-dashboard",
                title: "Домашняя страница",
                url: "/service/agent-dashboard/open",
                forceExternalOpen: false,
                iconUri: null,
            }

            this.openService(agentDashboardService, true, false)
        },
    },
})
